module.exports = __webpack_public_path__ + "static/media/A5.6f141ea6.jpg";